<template>
  <ss-modal
    v-show="isModalVisible"
    class="xl"
    title="Title"
    intro="bounceIn"
    outro ="bounceOut">
    <!-- HEADER -->
    <div slot="modal-header">
      <template v-if="isEdit">Edycja zabezpieczenia</template>
      <template v-else>Nowe zabezpieczenie</template>
      <i class="close" @click="closeModal(false)"></i>
    </div>
    <!-- BODY -->
    <div slot="modal-body" >
      <guarantee-form
       v-if="isViewLoaded"
       ref="guarantee-form"
       :guarantee-prop="guaranteeToEdit"
       :guarantors="guarantors" />
    </div>
    <!-- FOOTER -->
    <div slot="modal-footer">
      <d-button
        @click.prevent="closeModal(false)"
        :class="{ disabled : actionInProgress }"
        theme="danger">
        <i class="material-icons">close</i> Zamknij
      </d-button>
      <d-button
        @click.prevent="saveGuarantee"
        :class="{
          'ml-3': true,
          'isLoading': actionInProgress
        }"
        theme="success">
        <i class="material-icons">save</i> Zapisz
      </d-button>
    </div>
  </ss-modal>
</template>

<script>
import ClientUtils from '@/utils/client';
import SsModal from '@/components/common/SsModal'
import LarErrors from '@/helpers/Errors';
import GuaranteeForm from '@/components/client/GuaranteeForm.vue';
import GuaranteeUtils from '@/utils/guarantee.js';

export default {
  name: 'GuaranteeFormModal',
  components: {
    ClientUtils,
    SsModal,
    LarErrors,
    GuaranteeForm
  },
  props: {
    clientId: {
      required: true,
      type: Number
    },
    guarantors: {
      default: () => [],
      type: Array
    },
    isModalVisible: {
      default: false,
      type: Boolean
    },
    selectedGuarantee: {
      default: null,
      type: Object
    }
  },
  computed: {
    isEdit () {
      return this.selectedGuarantee && this.selectedGuarantee.id;
    }
  },
  data () {
    return {
      actionInProgress: false,
      guaranteeToEdit: null,
      isViewLoaded: false
    }
  },
  mounted () {
    this.guaranteeToEdit = this.selectedGuarantee;
    this.$nextTick(() => {
      this.isViewLoaded = true;
    })
  },
  methods: {
    async saveGuarantee() {
      try {
        this.actionInProgress = true;

        const isValid = await this.$refs['guarantee-form'].validateForm();
        if (!isValid) {
          this.actionInProgress = false;
          return
        }

        GuaranteeUtils.saveGuarantee(this.$refs['guarantee-form'].guarantee, this.clientId, this.saveSuccessHandler, this.saveFailHandler);
      } catch (error) {
        this.actionInProgress = false;
        console.error('Error validating form:', error);
      }
    },
    saveSuccessHandler () {
      this.actionInProgress = false;
      this.closeModal(true);
    },
    saveFailHandler (error) {
      console.error(error);
      this.actionInProgress = false;
      if (error && error.response && error.response.data && error.response.data.errors) {
        LarErrors.record(error.response.data.errors)
      }
    },
    closeModal (shouldReload = false) {
      this.$bus.$emit('guarantee-form-modal-close', shouldReload);
    }
  }
}
</script>
